import { useEffect, useState } from 'react';
import { getSecFilingOptions, getSecFilingsMeta } from '../../../api';

/** Loads SEC meta and filter options from the API. */
export default function useSecFilingBootstrap() {
  const [meta, setMeta] = useState(null);
  const [filterOptions, setFilterOptions] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const [metaRes, optionsRes] = await Promise.all([
          getSecFilingsMeta(),
          getSecFilingOptions(),
        ]);
        if (cancelled) return;
        setMeta(metaRes.data?.data || null);
        setFilterOptions(optionsRes.data?.data || null);
      } catch (error) {
        console.error('Error loading SEC filing bootstrap:', error);
      }
    };
    load();
    return () => { cancelled = true; };
  }, []);

  return { meta, filterOptions };
}
